import React from 'react';
import {  Button, Input, Icon } from 'semantic-ui-react';
import { IRestBloc } from '../classes';
import '../style/restBloc.css'
import { withTranslation, WithTranslation } from 'react-i18next';

interface IRestBlocState{
    restTime: number
}
interface IRestBlocProps extends WithTranslation{
    handleDelete: Function,
    bloc: IRestBloc
}
const RestBloc = (props: IRestBlocProps) => {
    return (
        <div className='restBloc'>
            <div className='infosContainer'>
                <h1>{props.t('bloc.rest')}</h1>
                <h4>{props.t('bloc.time')}</h4>
                <div className='restTimeSelector'>
                    <Button className='minusButton' onClick={() => props.bloc.setTime('-')}>
                        <Icon name='minus' size='large'></Icon>
                    </Button>
                    <span className='timeLayout'>
                        <Input type="text" inputmode="numeric" pattern="[0-9]*" maxLength="3" value={props.bloc.time} onChange={e => props.bloc.setTime(e)} transparent />
                        <p>{props.t('bloc.secs')}</p>
                    </span>
                    <Button className='plusButton' onClick={() => props.bloc.setTime('+')}>
                        <Icon name='plus' size='large'></Icon>
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default withTranslation('exerciseCreator') (RestBloc);